/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_DeveloperInputs */

const id_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pengembang`)
};

const ms_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembangun`)
};

const da_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udvikler`)
};

const de_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler`)
};

const en_us2_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const es_es2_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const es_mx2_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrollador`)
};

const fil_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const fr_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur`)
};

const it_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatore`)
};

const hu_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejlesztő`)
};

const nl_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontwikkelaar`)
};

const no_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvikler`)
};

const pl_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deweloper`)
};

const pt_br2_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

const pt_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

const ro_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezvoltator`)
};

const fi_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kehittäjä`)
};

const sv_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utvecklare`)
};

const vi_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà phát triển`)
};

const tr_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geliştirici`)
};

const cs_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vývojář`)
};

const bg_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const ru_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const uk_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розробник`)
};

const ar_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المطور`)
};

const hi_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर`)
};

const th_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้พัฒนา`)
};

const ja_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発元`)
};

const zh_cn2_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发商`)
};

const zh_hant1_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開發商`)
};

const ko_items_table_developer = /** @type {(inputs: Items_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개발자`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Items_Table_DeveloperInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_developer = /** @type {((inputs?: Items_Table_DeveloperInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_DeveloperInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_developer(inputs)
	if (locale === "ms") return ms_items_table_developer(inputs)
	if (locale === "da") return da_items_table_developer(inputs)
	if (locale === "de") return de_items_table_developer(inputs)
	if (locale === "en-US") return en_us2_items_table_developer(inputs)
	if (locale === "es-ES") return es_es2_items_table_developer(inputs)
	if (locale === "es-MX") return es_mx2_items_table_developer(inputs)
	if (locale === "fil") return fil_items_table_developer(inputs)
	if (locale === "fr") return fr_items_table_developer(inputs)
	if (locale === "it") return it_items_table_developer(inputs)
	if (locale === "hu") return hu_items_table_developer(inputs)
	if (locale === "nl") return nl_items_table_developer(inputs)
	if (locale === "no") return no_items_table_developer(inputs)
	if (locale === "pl") return pl_items_table_developer(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_developer(inputs)
	if (locale === "pt") return pt_items_table_developer(inputs)
	if (locale === "ro") return ro_items_table_developer(inputs)
	if (locale === "fi") return fi_items_table_developer(inputs)
	if (locale === "sv") return sv_items_table_developer(inputs)
	if (locale === "vi") return vi_items_table_developer(inputs)
	if (locale === "tr") return tr_items_table_developer(inputs)
	if (locale === "cs") return cs_items_table_developer(inputs)
	if (locale === "bg") return bg_items_table_developer(inputs)
	if (locale === "ru") return ru_items_table_developer(inputs)
	if (locale === "uk") return uk_items_table_developer(inputs)
	if (locale === "ar") return ar_items_table_developer(inputs)
	if (locale === "hi") return hi_items_table_developer(inputs)
	if (locale === "th") return th_items_table_developer(inputs)
	if (locale === "ja") return ja_items_table_developer(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_developer(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_developer(inputs)
	return ko_items_table_developer(inputs)
});
export { items_table_developer as "items.table.developer" }